// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pJbVW","logo":"styles_logo__vn2Xe","img":"styles_img__6vHGP"};